

import Swal from "sweetalert2";
import { useMeeting } from "@videosdk.live/react-sdk";

const Controls = (props) => {
    const { leave, toggleMic, toggleWebcam, end } = useMeeting();

    const handleEndMeeting = () => {



        Swal.fire({
            title: 'Make sure that you already captured Admin and Affiants Images.',
            text: 'Do you want to end the meeting?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'btn-danger',
            cancelButtonColor: 'btn-secondary',
            confirmButtonText: 'Yes, end the meeting!',
            cancelButtonText: 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
          }).then((result) => {
            if (result.isConfirmed) {
                try {
                    props.handleCopy();
                    end();
                } catch (error) {
                 
                }
            } else if (result.isDenied) {
                
            }
          });
    }

    const handleLeaveMeeting = () => {
        props.handleCopy();
        leave();
    }

    return (
        <div className="justify-content-between align-items-center mb-4 gap-2">
            <button className="btn btn-sm btn-label-danger" onClick={handleEndMeeting}>End Meeting</button>
            <button className="btn btn-sm btn-label-warning ms-2" onClick={handleLeaveMeeting}>Leave</button>
            <button className="btn btn-sm btn-label-info ms-2" onClick={() => toggleMic()}>Toggle Mic</button>
            <button className="btn btn-sm btn-label-info ms-2" onClick={() => toggleWebcam()}>Toggle WebCam</button>
        </div>
    );
}
 

export default Controls;